<script setup lang="ts">
    import type { AgentConversationListItem } from '~/composables/useAiAssistantPage';
    import { ENTITY_ICON_MAP } from '~/utils/aiEntityMeta';

    const props = defineProps<{
        agentConversation: AgentConversationListItem;
        active: boolean;
    }>();

    defineEmits<{
        click: [];
    }>();

    const agentIcon = computed(() => ENTITY_ICON_MAP[props.agentConversation.last_agent_key ?? ''] ?? 'fa-regular fa-sparkles');
</script>

<template>
    <button
        class="flex items-center gap-[10px] w-full min-w-0 text-left py-[2px] cursor-pointer text-[#FFFFF5] font-inter text-[14px] leading-none transition-opacity"
        :class="active ? 'opacity-100' : 'opacity-[0.92] hover:opacity-100'"
        @click="$emit('click')"
    >
        <i
            class="text-[12px] w-[14px] flex-shrink-0 text-[#FFFFF5]"
            :class="agentIcon"
        />
        <span class="flex-1 truncate">
            {{ agentConversation.title ?? $t('ai.sidebar.new_conversation') }}
        </span>
    </button>
</template>
